export const getApiErrorMessage = (error: any, defaultMsg: string): string => {
  const data = error?.response?.data;
  const err = data?.error;

  // error: { error: "..." } | { code, message, details: { detail } }
  if (typeof err === 'string') return err;
  if (err?.details?.detail) return err.details.detail;
  if (err?.message) return err.message;
  if (err?.error) return err.error;

  // legacy
  if (data?.message) return data.message;
  if (data?.detail) return data.detail;

  return error?.message || defaultMsg;
};
